import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { LoginService } from 'src/app/services/Login/login.service';
import { MetadataService } from 'src/app/services/Metadata/metadata.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/shared/common.service';
import { filter } from 'rxjs/operators';
import { SessionExpirationDialogComponent } from 'src/app/login/session-expiration-dialog/session-expiration-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';  
import { RoleService } from 'src/app/services/RoleManagement/role.service';
//import { LoginComponent } from 'src/app/services/Login/login.service';
interface Language {
  code: string;
  name: string;
  icon: string;
}

@Component({
  selector: 'app-dashboard-header',
  templateUrl: './dashboard-header.component.html',
  styleUrls: ['./dashboard-header.component.scss'],
})
export class DashboardHeaderComponent implements OnInit {
  languages: Language[] = [
    { code: 'en', name: 'USA', icon: 'https://img.freepik.com/free-vector/illustration-usa-flag_53876-18165.jpg' },
    { code: 'pt', name: 'Portugal', icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_Portugal.svg/800px-Flag_of_Portugal.svg.png' }
  ];

  hasGuideAdmin: boolean;
  currentLanguage: Language = this.languages[1];

  lang: string = '';
  activeRouteTab: boolean = false;
  loggedUserId: number = 0;
  loggedUser: any;
  isLeftmenu: boolean = true;
  tooltipContent: string = '';
  protected features = { isFullScreenRequested: false, isDarkModeRequested: false };
  private documentElement: any;
  roleId: any;
  isAddListingMenuDisabled: boolean = false
  private isPopupOpen = false;
  
  protected authorizePayload = { Email: "", Password: "" };
  protected toRemember: boolean = false;
  protected isEmailValid: boolean = true;
  protected isPasswordValid: boolean = true;
  private sessionTimeout: any;
  private expirationCheckTimeout: any;
 

  constructor(private translate: TranslateService, private router: Router, private loginService: LoginService, private commonService: CommonService,
    private metaService: MetadataService, @Inject(DOCUMENT) private document: any, public dialog: MatDialog, private roleService: RoleService) {
      this.roleService.userDetail$.subscribe(detail => {
        const {userId, roleId} = detail
        this.loggedUserId = userId
        this.roleId = roleId
      })
    }

  ngOnInit(): void {
    const storedLang = localStorage.getItem('lang');
    this.lang = storedLang || 'pt';
    this.currentLanguage = this.languages.find(lang => lang.code === this.lang) || this.languages[1];
  if(this.changeLanguage){
    if (storedLang && storedLang == this.currentLanguage.code) {
    this.refreshToken();
    }
  }
    this.updateTooltipContent();
    this.documentElement = document.documentElement;

    if (this.loggedUserId > 0) {
      this.metaService.GetAllRoles().subscribe((rolesRes: any) => {
        var roles = rolesRes;
        this.loginService.GetUserById(this.loggedUserId).subscribe((userRes: any) => {
          this.loggedUser = userRes;
          this.loggedUser.role = roles.filter((x: any) => x.id == userRes.roleId)?.[0]?.name;
        });
      });
    }

    // disable add listing menu option when user is currently on that page
    this.commonService.getIsAddListingPage().subscribe(isAddListing => this.isAddListingMenuDisabled = isAddListing)
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.isAddListingMenuDisabled = event.url.includes('add-listing');
      });

      this.hasGuideAdmin = this.roleId < 4 && !this.isAddListingMenuDisabled;
  }

  changeLanguage(language: Language): void {
    this.currentLanguage = language;
    this.translate.use(language.code);
    localStorage.setItem('lang', language.code);
    //this.refreshToken();
    window.location.reload();

  }

  updateTooltipContent() {
    if (this.loggedUser) {
      this.tooltipContent = `Hi! ${this.loggedUser.firstName} ${this.loggedUser.lastName}`;
    } else {
      this.tooltipContent = 'Please log in to view your profile';
    }
  }

  Userprofile() {
    this.router.navigate(['/profile']);
  }

  openFullscreen() {
    this.features.isFullScreenRequested = true;
    if (this.documentElement.requestFullscreen) {
      this.documentElement.requestFullscreen();
    } else if (this.documentElement.mozRequestFullScreen) {
      this.documentElement.mozRequestFullScreen();
    } else if (this.documentElement.webkitRequestFullscreen) {
      this.documentElement.webkitRequestFullscreen();
    } else if (this.documentElement.msRequestFullscreen) {
      this.documentElement.msRequestFullscreen();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const navbar = document.getElementById('navbarSupportedContent');
    const target = event.target as HTMLElement;
    
    if (navbar && !navbar.contains(target)) {
      navbar.classList.remove('show');
    }
  }

  onNavItemClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (target.closest('#nav-btn-mobile-view')) {
      
      const navbar = document.getElementById('navbarSupportedContent');
      if (navbar) {
        navbar.classList.remove('show');
      }
    }
  }

  closeFullscreen() {
    this.features.isFullScreenRequested = false;
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      this.document.msExitFullscreen();
    }
  }

  GotoMydashboard() { this.router.navigate(['/dashboard']) }
  GotomySystemAdmins() { this.router.navigate(['/admins']) }
  GotoCompanyOffices() { this.router.navigate(['/company-offices']) }
  GotoBroker() { this.router.navigate(['/broker']) }
  GotoOfficeManager() { this.router.navigate(['/office-manager']) }
  GotoAgent() { this.router.navigate(['/agent']) }
  // LogoutUser(){this.router.navigate(['/login'])}
  GotoContacts() { this.router.navigate(['/contact']) }
  Gototour() { this.router.navigate(['/tour']) }
  GotoTourDashboard() { this.router.navigate(['/tours']) }
  GotoSchedule_a_tour() { this.router.navigate(['/schedule-a-tour']) }
  GotoMy_tours() { this.router.navigate(['/my-tours']) }


  LogoutUser() {
    this.clearSessionTimeout();
    localStorage.removeItem("LoggedUserToken");
    localStorage.clear();
    this.roleService.resetDetails()
    this.router.navigate(['login']);
    location.reload();
  }

  closeSidebar() {
    this.isLeftmenu = false;
  }

  clearSessionTimeout() {
    if (this.sessionTimeout) {
      clearTimeout(this.sessionTimeout);
    }
    if (this.expirationCheckTimeout) {
      clearTimeout(this.expirationCheckTimeout);
    }
  }
  startSessionCheck() {
 
   
    this.clearSessionTimeout();
    this.sessionTimeout = setTimeout(() => {
     this.checkSessionExpiration();
    }, 3300 * 1000); 
  }

checkSessionExpiration() {

  if (this.isPopupOpen) {
    return;
  }

  const expirationTimestamp = localStorage.getItem("expiration");
  if (expirationTimestamp) {
    const currentTime = new Date().getTime();
    const expirationTime = Number(expirationTimestamp);
    const timeLeft = expirationTime - currentTime;
    const warningTimeInMilliseconds = 55 * 60 * 1000; // 55 minutes
 const autologoutTimeLimit = 10 * 60 * 1000; // 10 minutes

   
    if (timeLeft <= warningTimeInMilliseconds) {
      this.isPopupOpen = true
       const dialogRef = this.dialog.open(SessionExpirationDialogComponent, { disableClose: true });
      if (this.expirationCheckTimeout) {
        clearTimeout(this.expirationCheckTimeout);
      }

  
      this.expirationCheckTimeout = setTimeout(() => {
        console.log('No action taken within 10 minutes, logging out...');
        this. LogoutUser();
        this.isPopupOpen = false;
        dialogRef.close();
      }, autologoutTimeLimit);

      dialogRef.afterClosed().subscribe(result => {
        this.isPopupOpen = false;
        dialogRef.close();

        clearTimeout(this.expirationCheckTimeout)
        clearTimeout(autologoutTimeLimit);
       

        if (result === 'logout') {
          this. LogoutUser();
        } else if (result === 'continue') {
          this.refreshToken();
        }
      });
    } else {
     
      this.sessionTimeout = setTimeout(() => {
       
        
        this.checkSessionExpiration();
      }, 3300 * 1000); 
    }
  }
}


LoginErrorMessage: string = String();

  public refreshToken() {
    var payload = { Token: localStorage.getItem("LoggedUserToken"), RefreshToken: localStorage.getItem("LoggedUserToken") }
    this.loginService.refreshToken(payload).subscribe(res => {
      if (res?.accessToken) {
        localStorage.setItem("LoggedUserToken", res?.accessToken);
 
        const expirationTimeInSeconds = res.expireInSeconds;
        const expirationTimestamp = new Date().getTime() + (expirationTimeInSeconds * 1000);
        localStorage.setItem("expiration", expirationTimestamp.toString());
       this.startSessionCheck();
 
      }
    },
   
      err => {
        if (err.error.status == 423) {
          let date = new Date((String)(err.error.detail.split('Due Date expired: ')));
          this.router.navigateByUrl(`/PaymentDue?Email=${this.authorizePayload.Email}&DueDate=${date}`);
        }
        if (err.error.status == 401) {
          this.LoginErrorMessage = err.error.detail;
          this.isPasswordValid = false;
        }
        this.roleService.resetDetails()
      })
    return this.isPasswordValid;
  }

}






